function convertDateStringToTime(inputDateString: string) {
  const currentDate = new Date()
  const notificationDate = new Date(inputDateString)
  const isSameDay = currentDate.getDate() === notificationDate.getDate()
    && currentDate.getMonth() === notificationDate.getMonth()
    && currentDate.getFullYear() === notificationDate.getFullYear()

  if (isSameDay) {
    return notificationDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })
  }
  const yesterday = new Date(currentDate)
  yesterday.setDate(currentDate.getDate() - 1)

  if (
    notificationDate.getDate() === yesterday.getDate()
    && notificationDate.getMonth() === yesterday.getMonth()
    && notificationDate.getFullYear() === yesterday.getFullYear()
  ) {
    const date = notificationDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })

    return `Ontem às ${date}`
  }
  return notificationDate.toLocaleString('pt-BR', {
    day: 'numeric',
    month: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export default convertDateStringToTime
